module.exports = __webpack_public_path__ + "static/img/img43.38c7285.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img43.png
// module id = hqcM
// module chunks = 1